import { render, staticRenderFns } from "./CtaIcon.vue?vue&type=template&id=c470b17a&scoped=true"
import script from "./CtaIcon.vue?vue&type=script&lang=js"
export * from "./CtaIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c470b17a",
  null
  
)

export default component.exports